export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6918.8d03ded9.jpg";